import _ from 'lodash'

/**
 * Returns the HTML needed to display a SVG icon
 *
 * @param {String} name name of the icon
 * @param {String} [cssClass] string of class names for the svg
 * @param {Object} [opts]
 * @param {String} [opts.fill] color for the svg
 */
function icon(name, cssClass, opts={}) {
	var className = _.isString(cssClass) ? cssClass + ' ' : ''
	const fill = opts.fill ? opts.fill : ''
	return '<svg fill="' + fill + '" class="' + className + 'icon-' + name + '"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-' + name + '"></svg>'
}

export default icon

icon.__filename__ = 'components/icon.js'
